<template>
    <div class="img_load" style="display: none;width: 0;height: 0;">
        <img src="../assets/img/gif/t_01.png"/>
        <img src="../assets/img/gif/t_02.png"/>
        <img src="../assets/img/gif/t_03.png"/>
        <img src="../assets/img/gif/t_04.png"/>
        <img src="../assets/img/gif/t_05.png"/>
        <img src="../assets/img/gif/t_06.png"/>
        <img src="../assets/img/gif/t_07.png"/>
        <img src="../assets/img/gif/t_08.png"/>
        <img src="../assets/img/gif/t_09.png"/>
        <img src="../assets/img/gif/t_10.png"/>
        <img src="../assets/img/gif/t_11.png"/>
        <img src="../assets/img/gif/t_12.png"/>
        <img src="../assets/img/gif/t_13.png"/>
        <img src="../assets/img/gif/t_14.png"/>
        <img src="../assets/img/gif/t_15.png"/>
        <img src="../assets/img/gif/t_16.png"/>
        <img src="../assets/img/gif/t_17.png"/>
        <img src="../assets/img/gif/t_18.png"/>
        <img src="../assets/img/gif/t_19.png"/>
        <img src="../assets/img/gif/t_20.png"/>
        <img src="../assets/img/gif/t_21.png"/>
        <img src="../assets/img/gif/t_22.png"/>
        <img src="../assets/img/gif/t_23.png"/>
        <img src="../assets/img/gif/t_24.png"/>
        <img src="../assets/img/gif/t_25.png"/>
        <img src="../assets/img/gif/t_26.png"/>
        <img src="../assets/img/gif/t_27.png"/>
        <img src="../assets/img/gif/t_28.png"/>
        <img src="../assets/img/gif/t_29.png"/>
        <img src="../assets/img/gif/t_30.png"/>
        <img src="../assets/img/gif/t_31.png"/>
        <img src="../assets/img/gif/t_32.png"/>
        <img src="../assets/img/gif/t_33.png"/>
        <img src="../assets/img/gif/t_34.png"/>
        <img src="../assets/img/gif/t_35.png"/>
        <img src="../assets/img/gif/t_36.png"/>
        <img src="../assets/img/gif/t_37.png"/>
        <img src="../assets/img/gif/t_38.png"/>
        <img src="../assets/img/gif/t_39.png"/>
        <img src="../assets/img/gif/t_40.png"/>
        <img src="../assets/img/gif/t_41.png"/>
        <img src="../assets/img/gif/t_42.png"/>
        <img src="../assets/img/gif/t_43.png"/>
        <img src="../assets/img/gif/t_44.png"/>
        <img src="../assets/img/gif/t_45.png"/>
        <img src="../assets/img/gif/t_46.png"/>
        <img src="../assets/img/gif/t_47.png"/>
        <img src="../assets/img/gif/t_48.png"/>
        <img src="../assets/img/gif/t_49.png"/>
        <img src="../assets/img/gif/t_50.png"/>
        <img src="../assets/img/gif/t_51.png"/>
        <img src="../assets/img/gif/t_52.png"/>
        <img src="../assets/img/gif/t_53.png"/>
        <img src="../assets/img/gif/t_54.png"/>
    </div>
</template>
<style scoped>
.img_load{
    display: none;
}
</style>